module.exports = __webpack_public_path__ + "static/media/Hawkeye 2.6a70bd4e.jpg";